<script>
    import draggable from 'vuedraggable';

    export default {
        name: 'design-2021-assignment-show-matching-list-component',
        components: { draggable },
        props: {
            partIn: {
                type: Object,
                required: true
            },
            isExampleIn: {
                type: Boolean,
                required: true
            },
            projectId: {
                type: Number,
                required: false,
                default: 0
            },
            ords: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        data() {
            return {
                listOptions: [],
                listItems: [],
                answer: null,
                part: this.partIn,
            };
        },
        mounted() {
            this.listOptions = [...this.part.list_options];
            this.setListItems();
        },
        methods: {
            answersChanged(event) {
                const addedItem = event?.added?.element;

                if (!addedItem) return;

                const targetItem = this.listItems.find(item =>
                    item.answer.includes(addedItem)
                );

                if (!targetItem) return;

                targetItem.answer = targetItem.answer.filter(a => a.id !== addedItem.id);
                targetItem.answer.push(addedItem);

                if (targetItem.answer.length > 1) {
                    const removedAnswers = targetItem.answer.slice(0, -1);
                    this.listOptions.push(...removedAnswers);
                    targetItem.answer = targetItem.answer.slice(-1);
                }
            },
            saveAnswers() {
                if (!this.isExampleIn) {
                    this.alert.saving();
                    let matches = this.listItems.filter((listItem) => listItem.answer.length).map((item) => {
                        return {
                            item_id: item.id,
                            option_id: item.answer[0].id,
                        };
                    });
                    if (!this.answer) {
                        let data = {
                            part_id: this.partIn.id,
                            project_id: this.projectId,
                            value: matches[0]
                        };
                        matches.shift();
                        this.axios.post(this.routes.assignmentAnswer(), data).then(
                            (response) => {
                                if (this.ords) {
                                    this.partIn.addRelation('answers', response.data);
                                }
                                this.$emit('answer-created', response.data);
                                this.answer = response.data;
                            },
                            (error) => {
                                this.alert.ajaxError(error);
                            }
                        );
                    }
                    matches.forEach((match) => {
                        match.answer_id = this.answer.id;

                        let existingAnswer = this.answer.list_items.find((item) => item.id === match.item_id);

                        if (existingAnswer) {
                            this.axios.post(this.routes.assignmentAnswerListUpdate(existingAnswer.id), match).then(
                                (response) => {
                                    if (this.ords) {
                                        this.partIn.getAnswer().getListItem(id).update(response.data);
                                        this.answer = this.partIn.answers[0];
                                    } else {
                                        this.$emit('answer-list-item-updated', response.data);
                                        this.answer.list_items.map((item) => {
                                            if (item.id === response.data.id) {
                                                return response.data;
                                            }
                                            return item;
                                        });
                                    }
                                },
                                (error) => {
                                    this.alert.ajaxError(error);
                                }
                            );
                        } else {
                            this.axios.post(this.routes.assignmentAnswerList(), match).then(
                                (response) => {
                                    if (this.ords) {
                                        this.partIn.getAnswer().addRelation('list_items', response.data);
                                        this.answer = this.partIn.answers[0];
                                    } else {
                                        this.$emit('answer-list-item-added', response.data);
                                        this.answer.list_items.push(response.data);
                                    }
                                },
                                (error) => {
                                    this.alert.ajaxError(error);
                                }
                            );
                        }

                        this.alert.success();
                    });
                }
            },
            
            setListItems() {
                if (!this.isExampleIn) {
                    this.answer = this.part.answers.length ? this.part.answers[0] : null
                    this.listItems = this.part.list_items.map((listItem) => {
                        let answer = []
                        if (this.answer) {
                            let answerListItem = this.answer.list_items.find((answerListItem) => answerListItem.item_id === listItem.id)
                            if (answerListItem) {
                                answer.push(this.listOptions.find((listOption) => listOption.id === answerListItem.option_id));
                                this.listOptions = this.listOptions.filter((listOption) => listOption.id !== answerListItem.option_id);
                            }
                        }

                        return {
                            id: listItem.id,
                            value: listItem.value,
                            answer: answer
                        };
                    });
                } else {
                    this.listItems = this.part.list_items.map((listItem) => {
                        return {
                            id: listItem.id,
                            value: listItem.value,
                            answer: []
                        };
                    })
                }
            }
        },
        watch: {
            partIn: {
                handler: function(newVal) {
                    this.part = newVal;
                    this.setListItems();
                    this.listOptions = [...newVal.list_options];
                },
                deep: true
            }
        }
    };
</script>

<template>
    <div>
        <draggable
            class="draggable-answers"
            :list="listOptions"
            :sort="false"
            group="answerOptions"
            ghost-class="ghost">
            <span v-for="option in listOptions" :key="option.id" class="draggable-answer">
                {{ option.value }}
            </span>
        </draggable>

        <ul class="answers">
            <li v-for="listItem in listItems" class="question-answered">
                {{ listItem.value }}
                <draggable class="draggable-answer-zone" :list="listItem.answer" group="answerOptions" @change="answersChanged">
                    <span v-if=listItem.answer.length class="answer-option">
                        {{ listItem.answer[0].value }}
                    </span>
                </draggable>
            </li>
        </ul>

        <b-button variant="primary" class="btn-save" v-if="!isExampleIn" @click="saveAnswers">{{ $t('common.save') }}</b-button>
    </div>
</template>

<style scoped lang="scss">
    .draggable-answers {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        color: $white;
        gap: map-get($grid-gutter-spacing, 'ten') map-get($grid-gutter-spacing, 'fifteen');
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
        min-height: 51px;
    }

    .draggable-answer {
        padding: map-get($grid-gutter-spacing, 'eight');
        border-radius: $border-radius-sm;
        background-color: var(--primary);
        color: $white;

        &:hover {
            cursor: pointer;
        }
    }

    .answers {
        padding-left: 0;
    }

    .question-answered {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: map-get($grid-gutter-spacing, 'four') map-get($grid-gutter-spacing, 'fifteen');

        &:not(:last-child){
            margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
        }
    }

    .draggable-answer-zone {
        display: flex;
        flex: 1 1 auto;
        border: 3px dotted $border-color;
        min-height: 51px;
        min-width: 150px;
        padding: map-get($grid-gutter-spacing, 'four');

        .answer-option {
            @extend .draggable-answer;
        }

        .sortable-ghost{
            ~ .answer-option {
                display: none
            }
        }

        span.answer-option:has(+ .sortable-ghost){
            display: none
        }
    }

    @media(min-width: map-get($grid-breakpoints, 'md')) {
        .draggable-answer-zone {
            flex: 0 1 auto;
        }

    }

</style>